/*@flow*/
import * as I from 'immutable';
import { useEffect, useState } from 'react';
import { getCartoMapTask } from 'lib/getCartoMap';

export default (params: Object, config: Object) => {
  const [mapConfig, setMapConfig] = useState();
  let taskExecution;

  useEffect(() => {
    const mapTask = getCartoMapTask(config, { params });
    if (!taskExecution) {
      taskExecution = mapTask.map(setMapConfig).run();
    }
    return () => {
      if (taskExecution) {
        taskExecution && taskExecution.cancel();
        taskExecution = undefined;
      }
    };
  }, [I.fromJS(params).hashCode()]);

  return mapConfig;
};
